/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_InvalidInputs */

const en_error_inbound_invalid = /** @type {(inputs: Error_Inbound_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some lines cannot be announced on this purchase order.`)
};

/**
* | output |
* | --- |
* | "Some lines cannot be announced on this purchase order." |
*
* @param {Error_Inbound_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_invalid = /** @type {((inputs?: Error_Inbound_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_invalid(inputs)
});